import { BigNumber } from 'bignumber.js'

import type { ImportedInvoiceApproved } from '../types/importedInvoiceApproved'

export interface ImportedInvoiceDetailTotals {
  totalAmountExclVat: number
  totalAmountInclVat: number
  totalVatAmount: number
}

/** Sums the stored line amounts. Incl. VAT is the server-computed `amount`, never re-derived from the lines. */
export const getImportedInvoiceDetailTotals = (approved: ImportedInvoiceApproved): ImportedInvoiceDetailTotals => {
  const { totalNetAmount, totalTaxAmount } = approved.invoiceLines.reduce(
    (totals, line) => ({
      totalNetAmount: totals.totalNetAmount.plus(line.netAmount),
      totalTaxAmount: totals.totalTaxAmount.plus(line.taxAmount),
    }),
    { totalNetAmount: new BigNumber(0), totalTaxAmount: new BigNumber(0) },
  )

  return {
    totalAmountExclVat: totalNetAmount.toNumber(),
    totalAmountInclVat: Number(approved.amount),
    totalVatAmount: totalTaxAmount.toNumber(),
  }
}
